var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star/simple/thinsmooth",
    d: "M11.6474 2.85254C11.42 9.18871 6.33601 14.2727 -0.00015983 14.5001C6.33601 14.7275 11.42 19.8115 11.6474 26.1476C11.8748 19.8115 16.9588 14.7275 23.2949 14.5001C16.9588 14.2727 11.8748 9.18871 11.6474 2.85254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star/simple/thinsmooth_2",
    d: "M24.0082 0C23.9107 2.7155 21.7319 4.89434 19.0164 4.9918C21.7319 5.08927 23.9107 7.26811 24.0082 9.98361C24.1057 7.26811 26.2845 5.08927 29 4.9918C26.2845 4.89434 24.1057 2.7155 24.0082 0Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0f968813534af53f03b63ad78a21a0dc.svg";
export { ForwardRef as ReactComponent };